export function getCurrentValue(value, defaultValue) {
  return value !== undefined && value !== null ? value : defaultValue ? defaultValue : "";
}



// WEBPACK FOOTER //
// src/common/form-elements/text-input.js